export type PrimaryTimeUnit =
	'millisecond' | 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year';

export const DEFAULT_DATE_TEMPLATE = {
	year: 'yyyy',
	month: 'MMM',
	day: 'd MMM',
	hour: 'HH:mm',
	minute: 'HH:mm',
	second: 'HH:mm:ss',
	millisecond: 'HH:mm:ss SSS',
	none: 'P HH:mm:ss SSS',
};

const monthGetterName = (isUTC?: boolean) =>
	isUTC ? 'getUTCMonth' : 'getMonth';
const dateGetterName = (isUTC?: boolean) => (isUTC ? 'getUTCDate' : 'getDate');
const hoursGetterName = (isUTC?: boolean) =>
	isUTC ? 'getUTCHours' : 'getHours';
const minutesGetterName = (isUTC?: boolean) =>
	isUTC ? 'getUTCMinutes' : 'getMinutes';
const secondsGetterName = (isUTC?: boolean) =>
	isUTC ? 'getUTCSeconds' : 'getSeconds';
const millisecondsGetterName = (isUTC?: boolean) =>
	isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';

export const getUnitFromValue = (
	value: number | string | Date,
	isUTC?: boolean,
): PrimaryTimeUnit => {
	const date = new Date(value);
	const M = (date as any)[monthGetterName(isUTC)]() + 1;
	const d = (date as any)[dateGetterName(isUTC)]();
	const h = (date as any)[hoursGetterName(isUTC)]();
	const m = (date as any)[minutesGetterName(isUTC)]();
	const s = (date as any)[secondsGetterName(isUTC)]();
	const S = (date as any)[millisecondsGetterName(isUTC)]();

	const isSecond = S === 0;
	const isMinute = isSecond && s === 0;
	const isHour = isMinute && m === 0;
	const isDay = isHour && h === 0;
	const isMonth = isDay && d === 1;
	const isYear = isMonth && M === 1;

	if (isYear) {
		return 'year';
	} else if (isMonth) {
		return 'month';
	} else if (isDay) {
		return 'day';
	} else if (isHour) {
		return 'hour';
	} else if (isMinute) {
		return 'minute';
	} else if (isSecond) {
		return 'second';
	} else {
		return 'millisecond';
	}
};

export const getDateFormatFromValue = (
	value: number | string | Date,
	isUTC?: boolean,
	template?: {[kin in PrimaryTimeUnit]: string},
) => {
	const unit = getUnitFromValue(value, isUTC);
	return (template || DEFAULT_DATE_TEMPLATE)[unit];
};
